import main from '@/locales/kk/main';
import custom from '@/locales/kk/custom';
import customers from '@/locales/kk/customers';
import refund from '@/locales/kk/refund';
import exchanges from '@/locales/kk/exchanges';
import issue from '@/locales/kk/issue';
import logs from '@/locales/kk/logs';
import refundExchange from '@/locales/kk/refundExchange';
import settings from '@/locales/kk/settings';
import tasks from '@/locales/kk/tasks';
import orders from '@/locales/kk/orders';
import products from '@/locales/kk/products';
import feedback from '@/locales/kk/feedback';
import errors from '@/locales/kk/errors';
import scanner from '@/locales/kk/scanner';

export default {
    main,
    custom,
    customers,
    refund,
    exchanges,
    issue,
    logs,
    refundExchange,
    settings,
    tasks,
    orders,
    products,
    feedback,
    errors,
    scanner,
};